import React, { useState } from 'react'
import cn from 'classnames'

import Button from './Button'
import NumberPad from './NumberPad'
import useNumberPad from  '../hooks/useNumberPad'
import { ReactComponent as CloseIcon } from '../assets/icons/sidebar-modal-close.svg'


import styles from './QuantityEntryModal.module.scss'

const QuantityEntryModal = ({
  className,
  oldQuantity,
  onClose,
  showIncrementAndDecrement,
  updateItemQuantity,
}) => {
  const classNames = cn(styles.quantityEntryModal, className)
  const [overwriteQuantity, setOverwriteQuantity] = useState(true)
  const [
    output,
    onInput,
    rawValue,
  ] = useNumberPad(
    oldQuantity,
    (value) => value,
    (value) => parseInt(value) > 0,
    4
  )

  const onDecrementQuantity = () => {
    const newerQuantity = parseInt(rawValue) - 1
    if (newerQuantity >= 0) {
      onInput(newerQuantity, true)
      setOverwriteQuantity(true)
    }
  }

  const onIncrementQuantity = () => {
    const newerQuantity = parseInt(rawValue) + 1

    onInput(newerQuantity, true)
    setOverwriteQuantity(true)
  }

  const onTapNumberPad = (value) => {
    onInput(value, overwriteQuantity)
    if (overwriteQuantity) setOverwriteQuantity(false)
  }

  const handleUpdateQuantity = () => {
    updateItemQuantity(parseInt(rawValue))
    onClose()
  }

  let decrementButton = null
  let incrementButton = null
  if (showIncrementAndDecrement) {
    decrementButton = <div onClick={onDecrementQuantity} className={styles.incrementButton}>&mdash;</div>
    incrementButton = <div onClick={onIncrementQuantity} className={styles.incrementButton}>+</div>
  }

  let cancelButton = <Button className={styles.cancelButton} onClick={onClose}>Cancel</Button>
  if (document?.body?.clientWidth <= 800) {
    cancelButton = <CloseIcon className={styles.closeIcon} onClick={onClose} />
    decrementButton = null;
    incrementButton = null;
  }

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <div className={styles.body}>
          {decrementButton}
          <div className={styles.numberPadGrid}>
            <div className={styles.displayQuantity}>{output}</div>
            <NumberPad onTapButton={onTapNumberPad} />
          </div>
          {incrementButton}
          <div className={styles.rightSidebar}>
            <Button className={styles.confirmSetQuantity} onClick={handleUpdateQuantity}>Set Quantity</Button>
            {cancelButton}
          </div>
        </div>
      </div>
    </div>
  )
}

export default QuantityEntryModal
